import React from 'react';

export default function Footer() {
  return (
    <footer className="fixed bottom-0 w-full py-4 text-center bg-white/80 backdrop-blur border-t border-slate-200">
      <a
        href="https://donate.stripe.com/5kQ6oH99f72ze6OcIK4ZG00"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 bg-yellow-100 hover:bg-yellow-200 rounded-md transition-all duration-200 shadow-sm hover:shadow-md"
        style={{
          background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
          border: '2px solid #fcd34d'
        }}
      >
        💛 Support this project
      </a>
    </footer>
  );
}
